module.exports = __webpack_public_path__ + "img/1080_03.6bb0883f.jpg";